exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".purchaseBarcode{width:100px;height:20px}", ""]);

// exports
